/**
 * Pure, synchronous date formatter (not locale-aware — for locale-aware
 * display use useFormatDate / formatDate from ./utils.client / ./utils.server).
 * Falsy or unparseable input returns "".
 */
export type DateFormat = "yyyy-MM-dd" | "dd/MM/yy" | "dd/MM/yyyy";

export function formatDate(
  value: Date | string | undefined,
  format: DateFormat = "yyyy-MM-dd"
): string {
  if (!value) {
    return "";
  }

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const fullYear = String(date.getFullYear());
  const shortYear = fullYear.slice(-2);

  switch (format) {
    case "dd/MM/yy":
      return `${day}/${month}/${shortYear}`;
    case "dd/MM/yyyy":
      return `${day}/${month}/${fullYear}`;
    case "yyyy-MM-dd":
    default:
      return `${fullYear}-${month}-${day}`;
  }
}
